import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfigService } from '../../app-config.service';
import { SupportNumberService } from '../../common/help-menu';

@Component({
  selector: 'app-failed-payments-dialog',
  templateUrl: 'failed-payments-dialog.component.html',
  styleUrls: ['failed-payments-dialog.component.scss'],
  standalone: true,
  imports: [MatTooltipModule, MatDialogModule, MatButtonModule],
})
export class FailedPaymentsDialogComponent implements OnInit {
  userCanAccessBilling$: Observable<boolean>;
  supportNumber$: Observable<string>;
  constructor(
    private appConfigService: AppConfigService,
    private supportNumberService: SupportNumberService,
    public dialog: MatDialogRef<FailedPaymentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: object,
  ) {}
  ngOnInit(): void {
    this.supportNumber$ = this.supportNumberService.getSupportNumber();
    this.userCanAccessBilling$ = this.appConfigService.config$.pipe(
      map((config) => {
        return config.userCanAccessBilling;
      }),
    );
  }
  closeDialogAndGoToBilling(): void {
    this.dialog.close(true);
  }
  closeDialog(): void {
    this.dialog.close(false);
  }
}
